import React from "react";
import { LeadLink } from "web/react/components/lead-link";
import { SellerLogoCard } from "web/react/emo/seller-logo-card/seller-logo-card";
import { Text } from "web/react/emo/text";
import analytics from "web/script/analytics/analytics";
import { OOSRetailerInfoSerializer } from "web/types/serializers";

const RetailerCardWrapper = ({
    retailer,
    productId,
    children,
}: {
    retailer: OOSRetailerInfoSerializer;
    productId: string;
    children: React.ReactNode;
}): React.ReactElement => {
    const eventCustomData = {
        product_id: productId,
        buy_option_id: retailer.link_id.toString(),
        retailer_slug: retailer.retailer_slug,
    };

    const onCheckoutRetailerCardClick = (): void => {
        analytics.event(
            "oos-previously-available",
            "clicked",
            "checkout-retailer",
            false,
            eventCustomData,
            undefined,
            undefined,
            undefined,
            undefined,
            false
        );
    };

    return retailer.is_checkout ? (
        <a
            href={retailer.retailer_link}
            onClick={onCheckoutRetailerCardClick}
            data-testid={`retailer-card-${retailer.retailer_slug}`}
        >
            {children}
        </a>
    ) : (
        <LeadLink
            href={retailer.retailer_link}
            reason={"affiliate-retailer"}
            openInNewTab
            eventAction="clicked"
            eventCategory="oos-previously-available"
            eventLabel="affiliate-retailer"
            eventCustomData={eventCustomData}
            dataTestId={`retailer-card-${retailer.retailer_slug}`}
            eventTruncate={false}
        >
            {children}
        </LeadLink>
    );
};

export interface RetailerCardProps {
    retailer: OOSRetailerInfoSerializer;
    productId: string;
}

export function RetailerCard({ retailer, productId }: RetailerCardProps): React.ReactElement {
    return (
        <RetailerCardWrapper retailer={retailer} productId={productId}>
            <SellerLogoCard
                imageURL={retailer.retailer_image}
                sellerName={retailer.retailer_name}
                showExternalLinkIcon={!retailer.is_checkout}
                size={"sm"}
            >
                <Text textStyle={"body-xs"} color="secondary" as="span">
                    {retailer.last_seen_in_stock}
                </Text>
            </SellerLogoCard>
        </RetailerCardWrapper>
    );
}
